export const monitorReflectionLayerId = 1;
export const helpersLayerId = 2;
